/* @flow */

import { addClasses, removeClasses } from './utils';

const OFFSET = 1;

type HeaderState = {
  isPastOffset: boolean,
}

class Header {
  state: HeaderState;

  constructor () {
    this.state = {
      isPastOffset: false
    };

    const notifyEls = document.querySelectorAll('.c-header__inner, .c-navigation');

    window.addEventListener('scroll', () => {
      if (window.pageYOffset >= OFFSET && !this.state.isPastOffset) {
        this.setState({ isPastOffset: true });
        addClasses(notifyEls, 'is-header-minimised');
      }

      if (window.pageYOffset < OFFSET && this.state.isPastOffset) {
        this.setState({ isPastOffset: false });
        removeClasses(notifyEls, 'is-header-minimised');
      }
    });
  }

  setState(newState: Object) {
    this.state = Object.assign({}, this.state, newState);
  }
}

export default Header;
